<template>
  <div>
    <van-nav-bar
      title="人员年审"
    />
    <div class="myUpsection">
      <div class="fs">
        <div>
          <img src="../../assets/ava.png" class="myavtar" v-if="!sAvatarUrl">
          <img :src="sAvatarUrl" class="myavtar" v-else>
        </div>
        <div class="ml10 myAccountZone">
          <div class="myAccount">
            <span >{{name}}
            </span>
          </div>
          <div class="myAudit">
            <span >{{idCard}}</span>
          </div>
          <div class="myAudit2">
            <span v-if="auditResult != 1">
              <van-tag plain type="primary">未年审</van-tag>
            </span>
            <span v-if="auditResult === 1">
              <van-tag type="primary">已年审</van-tag>
            </span>
          </div>
        </div>
        <div class="fsac myBtn" >
          <van-button round type="info" size="small" color="#1678ff" @click="clear" plain>
            <div class="syBtnTxt9">退出</div>
          </van-button>
        </div>
      </div>
      
    </div>
    <!-- <div class="ht10"></div> -->
    <div class="myBotsection">
      <div class="ctlZone fsac"  @click="goto('homeland')" >
        <div class="fsac ctlbg">
        </div>
        <img src="../../assets/rl.png" class="ctlIcon">
      </div>
      <div class="fsac myBtn" @click="goto('homeland')"  v-if="auditResult !== 1">
        <van-button round type="info" size="small" color="#1678ff">
          <div class="syBtnTxt">我要年审</div>
        </van-button>
      </div>
      <div class="fsac myBtn"  v-if="auditResult == 1">
        
          <div class="passText">您已通过年审</div>

      </div>
      <div class="fsac myBtn" >
        <div class="ctltip" v-if="auditResult !== 1">为了您的安全使用 请尽快完成年审</div>
        <div class="ctltip" v-if="auditResult == 1">下次年审时间：2023-06~2023-07</div>
      </div>
      <!-- <div class="ht15"></div> -->
    </div>
    <!-- <div class="ht15"></div> -->
    <div class="myBotsection">
      <div class="fs tipZone">
        <div class="tipbg">
        </div>
        <img src="../../assets/my1.png" class="tipIcon">
        <div >
          <div class="tiptip">确保本人审核</div>
          <div class="tipdesc">非本人无法通过审核</div>
        </div>
      </div>
      <div class="fs tipZone">
        <div class="tipbg">
        </div>
        <img src="../../assets/light.png" class="tipIcon">
        <div >
          <div class="tiptip">识别光线适中</div>
          <div class="tipdesc">请保证光线不要过亮或过暗</div>
        </div>
      </div>
      <div class="fs tipZone">
        <div class="tipbg">
        </div>
        <img src="../../assets/smile.png" class="tipIcon">
        <div >
          <div class="tiptip">正面对准手机</div>
          <div class="tipdesc">保持您的脸出现在取景框内</div>
        </div>
      </div>
      <div class="fs tipZone">
        <div class="tipbg">
        </div>
        <img src="../../assets/opt.png" class="tipIcon">
        <div >
          <div class="tiptip">按提示操作</div>
          <div class="tipdesc">按提示眨眼或张嘴3-4次</div>
        </div>
      </div>
    </div>
    <div>
      <div class="menuCard fsb">
        <div class="fs" @click="target">
          <img src="../../assets/m1.png" class="mIcon">
          <div>个人信息</div>
        </div>
        <div>
        <van-icon name="arrow" size="4vw" color="#aaa"/>
        </div>
      </div>
      <div class="menuCard fsb">
        <div class="fs" @click="auditHistory">
          <img src="../../assets/m2.png" class="mIcon">
          <div>年审记录</div>
        </div>
        <div>
        <van-icon name="arrow" size="4vw" color="#aaa"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Toast, Button, Cell, Divider, NavBar, Tag, Icon} from 'vant'
  export default {
    components: {
      [Button.name]: Button,
      [Cell.name]: Cell,
      [Divider.name]: Divider,
      [NavBar.name]: NavBar,
      [Tag.name]: Tag,
      [Icon.name]: Icon
    },
    computed: {
      route () {
        return this.$route
      }
    },
    watch: {
      $route (to, from ) {
        // 监听路由变化, 实现类似 小程序的 onShow 事件
        if (to.path === '/my') {
          console.log(222)
          // do anything you want
        }
      }
    },
    mounted() {
      this.getUserInfo()
      this.CheckCanUserAudit()
      this.HelpUserGet()
      this.HelpUserGetAudiDetailList()
    },
    data() {
      return {
        sAvatarUrl: '',
        name: '',
        idCard: '',
        isAudit: false,
        list: [],
        finished: false,
        loading: false,
        jlList: [],
        phone: '',
        userType: 0,
        canIAuditText: '',
        auditResult: 0,
        auditLimit: 6,
        auditStatus: 0,
        currDayAuditCount: 0,
        selfAuditTimes: 0,
        dayAuditLimit: 3,
        isDied: 0
      };
    },
    methods: {
      target () {
        this.$router.push({path: '/target', query: {userType: this.userType}})
      },
      auditHistory () {
        this.$router.push({path: '/auditHistory', query: {userType: this.userType}})
      },
      async getUserInfo () {
        let {success, data, info} = await this.$api.getUserInfo()
        console.log(data)
        if (success) {
          this.name = data.name
          this.idCard = data.idCard
          this.phone = data.phone
          this.userType = Number(data.type)
          this.sAvatarUrl = data.auditImage
          window.localStorage.setItem('userInfo', JSON.stringify(data))
        } else {
          Toast(info)
        }
      },
      async HelpUserGetAudiDetailList () {
        let {success, info, data} = await this.$api.HelpUserGetAudiDetailList({page: 1, rows: 98})
        if (success) {
          this.jlList = data.rows
        }
      },
      async CheckCanUserAudit () {
        let {success, data, info} = await this.$api.CheckCanUserAudit()
        if (success) {
          this.canIAuditText = ''
        } else {
          this.canIAuditText = info
        }
      },
      canIAudit () {
        let success = false
        let msg
        if (this.auditResult === 1) {
          msg = '您本次年审已完成'
        }  else if (this.selfAuditTimes >= this.auditLimit) {
          msg = '您本次年审的次数超过限制,请联系工作人员'
        } else if (this.currDayAuditCount >= this.dayAuditLimit) {
          msg = '您今日的审核次数超过限制,请明天在试'
        }
        else {
          success = true
        }
        return {success, msg}
      },
      async HelpUserGet () {
        let {success, data, info} = await this.$api.HelpUserGet()
        console.log(data, success, info)
        if (success) {
          // auditStatus 0 未 1已年审 3 失联
          // auditResult 0 未年审 1 年审通过 2 年审未通过
          // auditLimit 总次数限制
          //dayAuditLimit 每日次数限制
          // currDayAuditCount 当日已审核次数
          // selfAuditTimes 本人核验次数
          let {auditResult, auditLimit, auditStatus, dayAuditLimit, currDayAuditCount, isDied, selfAuditTimes, auditImage} = data
          this.auditResult = auditResult
          this.auditLimit = auditLimit
          this.auditStatus = auditStatus
          this.dayAuditLimit = dayAuditLimit
          this.currDayAuditCount = currDayAuditCount
          this.isDied = isDied
          this.selfAuditTimes = selfAuditTimes
          this.sAvatarUrl = auditImage
        }
      },
      clear () {
        let key = `${this.idCard}-${this.name}`
        window.localStorage.removeItem(key)
        this.$router.replace('/index')
      },
      goto(path) {
        let {success, msg} = this.canIAudit()
        if (!success) {
          Toast(msg)
        } else {
          this.$router.push({path: '/homeland'})
        }
      },
      replace(path) {
        this.$router.replace(path)
      }
    }
  }
</script>

<style>
  .menuCard {
    border-radius: 6px;
    height: 28px;
    line-height: 28px;
    margin: 10px;
    padding: 15px;
    font-size: 16px;
    background: #fff;
  }
  .mIcon {
    width: 28px;
    height: 28px;
    z-index: 1;
    margin-right: 15px;
  }
  .syBtnTxt9{
    color: #1678ff;
    width: 74px;
    letter-spacing: 1px;
    font-size:14px
  }
  .myUpsection {
    /* height: 90px; */
    /* width: 100%; */
    background: #fff;
    padding: 20px 15px
  }
  .passText {
    color: #3187FF;
    text-shadow: 0px 0px 1px #3187FF;
    font-size: 20px;
    height: 30px;
    line-height: 30px;
  }
  .myavtar {
    width: 84px;
    height: 84px;
    border-radius: 50%;
  }

  .myAccountZone {
    width: 190px;
    letter-spacing: 1px;
  }

  .myAccount {
    margin-top: 6px;
    color: #333;
    font-size: 20px;
    text-shadow: 0px 0px 1px #333;

  }

  .myAudit {
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    color: #454545;
  }

  .myAudit2 {
    height: 24px;
    line-height: 24px;
    font-size: 13px;
    color: #959595;
  }

  .myBotsection {
    background: #fff;
    height: auto;
    padding: 15px;
    margin: 10px;
    margin-bottom: 0;
    border-radius: 6px;
  }

  .my-title {
    color: #111;
    font-size: 15px !important;
    height: 42px;
    line-height: 42px;
  }

  .myBtnTxt {
    color: black;
    width: 90px;
    letter-spacing: 1px;
    font-size: 13px;
  }
  .ctlZone {
    padding: 15px 20px;
  }
  .ctlbg {
    width: 80px;
    height: 80px;
    background-color: #298BFF;
    border-radius: 50%;
    opacity: 0.1;
    z-index: 0;
    position: relative;
    left: 18px;
  }
  .ctlIcon {
    width: 40px;
    height: 40px;
    z-index: 1;
    position: relative;
    right: 42px;
  }
  .ctltip {
    margin-top: 15px;
    color: #777;
    font-size: 12px;
    text-align: center;
  }
  .tipZone {
    padding: 10px 10px 0px 50px;
  }
  .tipbg {
    width: 50px;
    height: 50px;
    background-color: #fff;
    border-radius: 50%;
    opacity: 0.1;
    z-index: 0;
    position: relative;
  }
  .tipIcon {
    width: 25px;
    height: 25px;
    z-index: 1;
    position: relative;
    right: 15.5px;
    top: 6px
  }
  .tiptip {
    height: 20px;
    line-height: 20px;
    color: #444;
    font-size: 15px;
    text-align: left;
    text-shadow: 0px 0px 1px #333;
  }
  .tipdesc {
    height: 20px;
    line-height: 20px;
    color: #555;
    font-size: 12px;
    text-align: left;
  }
</style>